import React  from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Callback } from "./auth/CallBack.jsx";
import { Auth0ProviderWithNavigate } from "./auth/Auth0ProviderWithNavigate.jsx";
import { ProtectedRoute } from "./auth/ProtectedRoute.jsx";
import Dashboard from './Dashboard.jsx';
import ReportDashboardPage from './ReportDashboardPage.jsx';
import RootRedirect from './RootRedirect.jsx';
import ManualEntryPage from './ManualEntryPage.jsx';
import VehicleDetailPage from './VehicleDetailPage.jsx';
import DriveOffReportPage from './DriveOffReportPage.jsx';
import SettingsPage from './SettingsPage.jsx';
import ShellRouteBoundary from './layout/ShellRouteBoundary.jsx';

const AppContent = () => (
  <Routes>
    <Route element={<ShellRouteBoundary />}>
      <Route path="/" element={<ProtectedRoute component={RootRedirect} />} />
      <Route path="/dashboard" element={<ProtectedRoute component={Dashboard} />} />
      <Route path="/group/:groupName" element={<ProtectedRoute component={Dashboard} />} />
      <Route path="/reportDashboard" element={<ProtectedRoute component={ReportDashboardPage} />} />
      <Route path="/manual-entry" element={<ProtectedRoute component={ManualEntryPage} />} />
      <Route path="/drive-off-report" element={<ProtectedRoute component={DriveOffReportPage} />} />
      <Route path="/vehicle/:plate" element={<ProtectedRoute component={VehicleDetailPage} />} />
      <Route path="/settings" element={<ProtectedRoute component={SettingsPage} />} />
      <Route path="/callback" element={<Callback />} />
    </Route>
  </Routes>
);


const Main = () => {
    return (
        <div>
            <HashRouter>
                <Auth0ProviderWithNavigate>
                    <AppContent />
                </Auth0ProviderWithNavigate>
            </HashRouter>
        </div>
    );
};
 
 export default Main
 